var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',[_c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("404 not found")]),_c('router-link',{attrs:{"to":{name: 'login'}}},[_vm._v(" "+_vm._s(_vm.$t('Terug naar inlogscherm'))+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }